import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components/native';
import { useField, useFormikContext } from 'formik';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { View, Text, TextInput, Modal, Pressable } from 'react-native';

import {
  elRed,
  elGray
} from '../../styles/colors';

export const CorrespondenceContainer = styled(View)`
  padding: 40px;
`;

